import { render, staticRenderFns } from "./dstr-gst-invoice-list.vue?vue&type=template&id=23d78c21"
import script from "./dstr-gst-invoice-list.vue?vue&type=script&lang=js"
export * from "./dstr-gst-invoice-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports